import { BaseTag }   from "mixs/base/base_mixin";
import { HistoriesBase } from "mixs/histories/base";
export class HistoriesShow extends HistoriesBase {
  init(){
    super.init();
    this.watch();
  }
  date() {
    return this.datetimeFormat(this.opts.created_at);
  }
}
riot.mixin('histories.show', HistoriesShow as riot.TagMixin)
